import { faPlus } from '@fortawesome/pro-light-svg-icons';

import { Button } from '@/components/ui/button/button.component';

interface StandaloneTabContentProps {
  withTitle?: boolean;
  onChangeContentToStandalone(value: boolean): void;
}

export function StandaloneTabContent({ withTitle = true, onChangeContentToStandalone }: StandaloneTabContentProps) {
  return (
    <div className="h-fit">
      {withTitle && (
        <span className="text-xl text-gray-800 font-semibold" data-testid="title-standalone-tab-content">
          Guia avulsa
        </span>
      )}
      <div className="flex flex-col justify-between h-full">
        <div>
          <p className="text-gray-800">Essa modalidade é ideal para você: </p>

          <ul className="list-bullet space-y-1">
            <li className="text-gray-700 ml-1 marker:mr-2">
              Comprar procedimentos complementares (no mesmo local ou próximos).
            </li>
            <li className="text-gray-700 ml-1">Incluir algum exame que foi esquecido.</li>
            <li className="text-gray-700 ml-1">Gerar uma guia de encaixe.</li>
          </ul>
        </div>

        <Button
          startIcon={faPlus}
          className="mt-4"
          onClick={() => onChangeContentToStandalone(true)}
          data-testid="button--add-standalone-tab-content"
        >
          Adicionar guia avulsa
        </Button>
      </div>
    </div>
  );
}
